import React from 'react';
import type { AssessmentItem, TrainingItem } from './types';
import { Pill } from './Pill';
import {
  fmtCm, fmtFloat, fmtForce, fmtInt, fmtKm, fmtMin, fmtPaceMi, fmtPct, fmtSpeed, fmtYd,
} from './utils/format';

interface Props {
  item: TrainingItem | AssessmentItem;
}

/**
 * Structured per-kind metric grid for the DayPanel accordion body.
 * Replaces the Phase 1 raw `JSON.stringify` dump.
 */
export function ActivityDetail({ item }: Props) {
  if (item.kind === 'garmin_daily') {
    return (
      <div className="grid grid-cols-2 gap-2">
        <Pill label="Steps" value={fmtInt(item.steps)} />
        <Pill label="Distance" value={fmtKm(item.distance_m)} />
        <Pill label="Calories" value={item.calories ? `${Math.round(item.calories)} kcal` : null} />
        <Pill
          label="Avg HR"
          value={item.hr_avg != null ? `${Math.round(item.hr_avg)} bpm` : null}
        />
      </div>
    );
  }
  if (item.kind === 'catapult_session') {
    return (
      <div className="grid grid-cols-2 gap-2">
        <Pill label="Duration" value={fmtMin(item.duration_min)} />
        <Pill label="Distance" value={fmtKm(item.distance_m)} />
        <Pill
          label="Player Load"
          value={item.player_load ? `${Math.round(item.player_load)}` : null}
        />
        <Pill label="Max Velocity" value={fmtSpeed(item.max_velocity)} />
        <Pill label="Sprint Distance" value={fmtYd(item.sprint_distance_m)} />
      </div>
    );
  }
  if (item.kind === 'terra_activity') {
    const minutes = item.duration_s ? Math.round(item.duration_s / 60) : null;
    return (
      <div className="grid grid-cols-2 gap-2">
        <Pill label="Distance"  value={fmtKm(item.distance_m)} />
        <Pill label="Duration"  value={fmtMin(minutes)} />
        <Pill label="Pace"      value={fmtPaceMi(item.pace_s_per_km)} />
        <Pill label="Avg HR"    value={item.hr_avg != null ? `${Math.round(item.hr_avg)} bpm` : null} />
        <Pill label="Calories"  value={item.calories ? `${Math.round(item.calories)} kcal` : null} />
      </div>
    );
  }
  // hawkin_test
  return (
    <div className="grid grid-cols-2 gap-2">
      <Pill label="Jump Height" value={fmtCm(item.jump_height_m)} />
      <Pill label="Peak Force" value={fmtForce(item.peak_force_n)} />
      <Pill label="RSI" value={fmtFloat(item.rsi, 2)} />
      <Pill label="L/R Braking" value={fmtPct(item.lr_braking_pct)} />
      <Pill label="L/R Propulsive" value={fmtPct(item.lr_propulsive_pct)} />
    </div>
  );
}
